import { FC } from "react";
import { t } from "i18next";

// Utilities
import { roundNumber } from "@/_helpers/number_functions";

// Styles
import { Fire } from "@carbon/icons-react";

// Components
import Tag from "@/components/tag";
import { Box, Skeleton } from "@mui/material";


interface _MacroTagsProps {
    servings: number;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    isLoading?: boolean;
}

const MacroTags: FC<_MacroTagsProps> = ({
    servings,
    calories,
    protein,
    carbs,
    fat,
    isLoading = false,
}) => {
    return (
        <Box className='text-primary' position='absolute' bottom={0} left={0} display='flex' gap={0.5} p={1}
            sx={{flexDirection: { xs: 'column', xl: 'row' }}}
            >
            {/* Calories */}
            {isLoading ? 
                <Skeleton variant="rectangular" width="64px" height="26px" /> :
                <>
                    <Tag 
                        icon={<Fire style={{marginLeft: '-4px'}} />}
                        colour="grey"
                        outlined
                        sx={{padding: "2px 4px !important", borderRadius: '4px !important', pointerEvents: 'none'}}
                        label={`${roundNumber(calories / servings, 0)} ${t('components.nutritionBuilder.macros.kcal')}`}
                        />
                    <Tag
                        colour="purple"
                        outlined
                        sx={{padding: "2px 4px !important",borderRadius: '4px !important', pointerEvents: 'none'}}
                        label={`${roundNumber(protein / servings, 0)}P/${roundNumber(carbs / servings, 0)}C/${roundNumber(fat / servings, 0)}F`}
                        />
                </> 
            }
        </Box>
    );
};

export default MacroTags;